import { render, staticRenderFns } from "./LeaderColumn.vue?vue&type=template&id=38ef3e8c&scoped=true"
import script from "./LeaderColumn.vue?vue&type=script&lang=js"
export * from "./LeaderColumn.vue?vue&type=script&lang=js"
import style0 from "./LeaderColumn.vue?vue&type=style&index=0&id=38ef3e8c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38ef3e8c",
  null
  
)

export default component.exports